import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { SearchOff } from '@mui/icons-material';

/**
 * Catch-all for paths that match no route.
 *
 * GP-1204: before this existed, <Routes> simply rendered nothing for an
 * unmatched path — the whole app chrome disappeared, no error was thrown and
 * no request was made, so a stale link (e.g. a pre-rename
 * `/order-fulfillment/billing`) looked like a hard crash. A dead link must
 * always land on something explicit and recoverable.
 */
const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{ padding: 4, width: '100%', textAlign: 'center' }}
          data-testid="not-found-page"
        >
          <SearchOff sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <Typography component="h1" variant="h4" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" paragraph>
            We couldn&apos;t find a page at <strong>{pathname}</strong>.
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            The link may be out of date. Try the dashboard, or go back and use
            the sidebar navigation.
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              onClick={() => navigate('/order-fulfillment/operations-dashboard')}
              sx={{ mr: 2 }}
            >
              Go to Dashboard
            </Button>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default NotFound;
